// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__A1pQI","content":"Dashboard_content__R9GzB"};